import type {OverviewTask, TaskType} from 'services/tasks/types';

// Merge tasks by manifestations id, and merge taskTypes.
export const mergeDuplicateManifestations = (
  overviewTasks: OverviewTask[],
): OverviewTask[] => {
  const merged: OverviewTask[] = [];
  const byManifestationId = new Map<string, OverviewTask>();

  overviewTasks.forEach(ot => {
    const existing = ot.manifestationId
      ? byManifestationId.get(ot.manifestationId)
      : undefined;

    if (!existing) {
      ot.taskTypes.sort(sortTaskTypes);
      if (ot.manifestationId) {
        byManifestationId.set(ot.manifestationId, ot);
      }
      merged.push(ot);
    } else {
      ot.taskTypes.forEach(taskType => {
        if (!existing.taskTypes.includes(taskType)) {
          existing.taskTypes.push(taskType);
        }
      });

      existing.taskTypes.sort(sortTaskTypes);
    }
  });

  return merged;
};

export const sortTaskTypes = (a: TaskType, b: TaskType): number => {
  const order = [undefined, '', 'ml', 'change', 'pre', 'new'];

  if (order.indexOf(a) === order.indexOf(b)) {
    return 0;
  }

  return order.indexOf(a) > order.indexOf(b) ? 1 : -1;
};
